// 课后拓展  常量
export const WORK_LIST = 'work_list';
export const DEL_WORK = 'del_work';
export const DEL_WORK_LIST = 'del_work_list';
export const EDIT_WORK = 'edit_work';
export const ADD_WORK = 'add_work';
export const GET_WORK_ID = 'get_work_id';
export const GET_WORK_FJ = 'get_work_fj';
export const POST_WORK = 'post_work';
export const GET_WOEK_TOPIC = 'get_work_topic';
export const GET_NOT_SUBMIT = 'get_not_submit';
export const GET_NOT_SUBMIT_TOTAL = 'get_not_submit_total';
export const GET_ID_SCORING = 'get_id_scoring';
export const EDIT_EDIT_SCORING = 'edit_edit_scoring';
export const GET_ID_SCORING_FJ = 'get_id_scoring_fj';
export const EDIT_ID_SCORING = 'edit_id_scoring';
export const BATCH_TOTAL = 'batch_total';
export const BATCH_REJECT = 'batch_reject';
export const EXPORT_EXCEL = 'export_excel';
export const REMIND_STUDENT = 'remind_student';
export const SET_HOMEWORK_INFO = 'set_homework_info';



// WEBPACK FOOTER //
// ./src/store/khExpand/type.js